import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, Transition as _Transition, createBlock as _createBlock, unref as _unref } from "vue"

const _hoisted_1 = { class: "app-header" }
const _hoisted_2 = { class: "app-header__container" }
const _hoisted_3 = { class: "app-header__left" }
const _hoisted_4 = {
  key: 0,
  viewBox: "0 0 24 24",
  width: "24",
  height: "24",
  fill: "none"
}
const _hoisted_5 = {
  key: 1,
  viewBox: "0 0 24 24",
  width: "24",
  height: "24",
  fill: "none"
}
const _hoisted_6 = {
  key: 1,
  class: "app-nav hide-mobile"
}
const _hoisted_7 = { class: "app-nav__list" }
const _hoisted_8 = { class: "app-nav__text" }
const _hoisted_9 = { class: "app-nav__text" }
const _hoisted_10 = { class: "app-nav__text" }
const _hoisted_11 = ["aria-expanded"]
const _hoisted_12 = { class: "app-nav__text" }
const _hoisted_13 = {
  key: 0,
  class: "dropdown admin-dropdown",
  style: {"left":"0","right":"auto"}
}
const _hoisted_14 = { class: "dropdown__menu" }
const _hoisted_15 = ["aria-expanded"]
const _hoisted_16 = { class: "app-nav__text" }
const _hoisted_17 = {
  key: 0,
  class: "dropdown tenders-dropdown",
  style: {"left":"0","right":"auto"}
}
const _hoisted_18 = { class: "dropdown__menu" }
const _hoisted_19 = {
  key: 2,
  class: "app-breadcrumb"
}
const _hoisted_20 = { class: "breadcrumb-container" }
const _hoisted_21 = ["title"]
const _hoisted_22 = { class: "hide-mobile" }
const _hoisted_23 = ["title"]
const _hoisted_24 = { class: "hide-mobile" }
const _hoisted_25 = ["title"]
const _hoisted_26 = {
  key: 3,
  class: "app-breadcrumb"
}
const _hoisted_27 = { class: "breadcrumb-container" }
const _hoisted_28 = ["title"]
const _hoisted_29 = { class: "hide-mobile" }
const _hoisted_30 = ["title"]
const _hoisted_31 = { class: "hide-mobile" }
const _hoisted_32 = ["title"]
const _hoisted_33 = {
  key: 4,
  class: "app-breadcrumb"
}
const _hoisted_34 = { class: "breadcrumb-container" }
const _hoisted_35 = ["title"]
const _hoisted_36 = { class: "hide-mobile" }
const _hoisted_37 = ["title"]
const _hoisted_38 = { class: "hide-mobile" }
const _hoisted_39 = ["title"]
const _hoisted_40 = { class: "app-header__right" }
const _hoisted_41 = {
  key: 1,
  class: "loading-container"
}
const _hoisted_42 = {
  key: 3,
  class: "app-header__profile"
}
const _hoisted_43 = {
  key: 0,
  class: "app-header__avatar"
}
const _hoisted_44 = { class: "app-header__username hide-mobile" }
const _hoisted_45 = {
  key: 0,
  class: "dropdown"
}
const _hoisted_46 = { class: "dropdown__menu" }
const _hoisted_47 = { class: "dropdown__header" }
const _hoisted_48 = { class: "app-header__avatar app-header__avatar--large" }
const _hoisted_49 = { class: "dropdown__user-info" }
const _hoisted_50 = { class: "dropdown__user-name" }
const _hoisted_51 = { class: "dropdown__user-email" }
const _hoisted_52 = {
  key: 0,
  class: "mobile-nav-overlay"
}
const _hoisted_53 = { class: "mobile-nav" }
const _hoisted_54 = { class: "mobile-nav__list" }
const _hoisted_55 = { class: "mobile-nav__text" }
const _hoisted_56 = { class: "mobile-nav__text" }
const _hoisted_57 = { class: "mobile-nav__item" }
const _hoisted_58 = { class: "mobile-nav__text" }
const _hoisted_59 = { class: "mobile-nav__item" }
const _hoisted_60 = { class: "mobile-nav__text" }
const _hoisted_61 = { class: "mobile-nav__item" }
const _hoisted_62 = { class: "mobile-nav__text" }
const _hoisted_63 = { class: "mobile-nav__item" }
const _hoisted_64 = { class: "mobile-nav__text" }
const _hoisted_65 = { class: "mobile-nav__text" }
const _hoisted_66 = { class: "mobile-nav__text" }

import { ref, computed, watch, onMounted, onBeforeUnmount } from 'vue'
import { useAuthStore, useUiStore, useProjectStore } from '@/stores'
import { useRouter, useRoute } from 'vue-router'
import { useI18n } from 'vue-i18n'
import type { User } from '@/types'

// Import tender stores (with try-catch for graceful fallback)
import archiWebAuthService from '../services/archiweb.auth.service'
import permissionService from '../services/permission.service'
import { useNotifications } from '@/composables/useNotifications'
import axios from 'axios'

// Components
import LanguageSelector from './common/LanguageSelector.vue'
import NotificationIcon from './notifications/NotificationIcon.vue'
import AppButton from './base/AppButton.vue'
import PermissionGuard from './common/PermissionGuard.vue'

// Store and router

export default /*@__PURE__*/_defineComponent({
  __name: 'TopBar',
  setup(__props) {

/// <reference types="vue" />
// @ts-ignore
let useTenderStore: any = null
let useTenderApplicationStore: any = null

try {
  const tenderStoreModule = require('@/stores/tenderStore')
  useTenderStore = tenderStoreModule.useTenderStore
} catch (e) {
  console.warn('TenderStore not available')
}

try {
  const applicationStoreModule = require('@/stores/tenderApplicationStore')
  useTenderApplicationStore = applicationStoreModule.useTenderApplicationStore
} catch (e) {
  console.warn('TenderApplicationStore not available')
}

// Services
const authStore = useAuthStore()
const uiStore = useUiStore()
const projectStore = useProjectStore()
const router = useRouter()
const route = useRoute()
const { t } = useI18n()

// Initialize tender and application stores
const tenderStore = useTenderStore ? useTenderStore() : null
const applicationStore = useTenderApplicationStore ? useTenderApplicationStore() : null
const { notifySuccess, notifyError } = useNotifications()

// Reactive data
const menuVisible = ref(false)
const adminMenuVisible = ref(false)
const tendersMenuVisible = ref(false)
const errorMessage = ref<string | null>(null)
const mobileMenuOpen = ref(false)

// Computed properties
const user = computed((): User | null => authStore.getUser)
const isAuthenticated = computed((): boolean => authStore.isAuthenticated)
const isLoading = computed((): boolean => authStore.loading)
// expose `loading` for template compatibility (some templates reference `loading`)
const loading = isLoading
const getError = computed((): string | null => uiStore.error)
const getCurrentProjectName = computed((): string => projectStore.currentProject?.name || '')

const userInitials = computed((): string => {
  if (!user.value || !user.value.firstName) return '?'
  const nameParts = [user.value.firstName, user.value.lastName].filter(Boolean)
  if (nameParts.length >= 2) {
    return `${nameParts[0][0]}${nameParts[1][0]}`.toUpperCase()
  }
  return nameParts[0][0].toUpperCase()
})

// Check if we're currently in a project view
const isInProjectView = computed((): boolean => {
  return route.name === 'ProjectDetails' && Boolean(route.params.projectId)
})

// Check if we're currently in a tender view
const isInTenderView = computed((): boolean => {
  return route.name === 'TenderDetails' && Boolean(route.params.id)
})

// Check if we're currently in a tender application view
const isInApplicationView = computed((): boolean => {
  return route.name === 'ApplicationDetails' && Boolean(route.params.id)
})

const isDashboardActive = computed((): boolean => {
  // Dashboard is active for home route OR admin dashboard route
  try {
    return route.path === '/' || route.path === '/admin'
  } catch (e) {
    return false
  }
})

const isAdminActive = computed((): boolean => {
  // Active when current path is under /admin BUT NOT the admin dashboard itself
  // Admin dropdown should only be active on admin sub-pages, not on /admin dashboard
  try {
    return adminMenuVisible.value || (route.path.startsWith('/admin') && route.path !== '/admin')
  } catch (e) {
    return adminMenuVisible.value
  }
})

const isTendersActive = computed((): boolean => {
  // Active when current path includes tenders or tender applications or when tenders menu is open
  try {
    return tendersMenuVisible.value || route.path.includes('/tenders') || route.path.includes('/my-applications')
  } catch (e) {
    return tendersMenuVisible.value
  }
})

// Get current project name from store
const currentProjectName = computed((): string => {
  if (!isInProjectView.value) return ''

  // Get project name from store
  const projectName = getCurrentProjectName.value
  if (projectName) {
    return projectName
  }

  // Fallback to project ID if name not available
  return (route.params.projectId as string) || 'Project'
})

// Get current tender name from store
const currentTenderName = computed((): string => {
  if (!isInTenderView.value) return ''

  // Get tender name from store
  const tender = tenderStore?.getCurrentTender || tenderStore?.currentTender
  if (tender) {
    return tender.title || `Tender ${tender.referenceNumber || tender.id}`
  }

  // Fallback to tender ID if name not available
  return `Tender ${route.params.id}` || 'Tender'
})

// Get current application name from store
const currentApplicationName = computed((): string => {
  if (!isInApplicationView.value) return ''

  // Get application name from store
  const application = applicationStore?.selectedApplication || applicationStore?.currentApplication
  if (application) {
    return `Application ${application.referenceNumber || application.id}`
  }

  // Fallback to application ID if name not available
  return `Application ${route.params.id}` || 'Application'
})

// Methods
const toggleMenu = (): void => {
  menuVisible.value = !menuVisible.value
}

const toggleAdminMenu = (): void => {
  adminMenuVisible.value = !adminMenuVisible.value
}

const toggleTendersMenu = (): void => {
  tendersMenuVisible.value = !tendersMenuVisible.value
}

const closeMenu = (): void => {
  menuVisible.value = false
}

const toggleMobileMenu = (): void => {
  mobileMenuOpen.value = !mobileMenuOpen.value
}

const login = async (): Promise<void> => {
  try {
    // For OAuth login, we don't need credentials - redirect to auth server
    await archiWebAuthService.login()
  } catch (error) {
    console.error('Login error:', error)
    uiStore.setError('Failed to start login process')
  }
}

const goToHome = (): void => {
  router.push('/')
  closeMenu()
}

const goToUserHome = (): void => {
  // Redirect based on user type
  const userType = user.value?.type
  if (userType === 'FIRM_OWNER' || userType === 'FIRM_MEMBER') {
    router.push('/firms')
  } else if (userType === 'CLIENT') {
    router.push('/firms/client-dashboard')
  } else if (userType === 'ADMIN') {
    // Admin users redirect to admin dashboard
    router.push('/admin')
  } else {
    // Fallback for any other user types
    router.push('/firms/client-dashboard')
  }
  closeMenu()
  mobileMenuOpen.value = false
}

const navigateTo = (path: string): void => {
  console.log('Navigating to:', path)
  console.log('User:', user.value)
  console.log('User type:', user.value?.type)
  console.log('Is admin check:', user.value?.type === 'ADMIN')
  router.push(path)
  closeMenu()
  adminMenuVisible.value = false
  tendersMenuVisible.value = false
  mobileMenuOpen.value = false
}

const goToSettings = (): void => {
  router.push('/settings')
  closeMenu()
}

const creatingFirm = ref(false)
const createFirmWithData = async (): Promise<void> => {
  if (creatingFirm.value) return
  creatingFirm.value = true
  adminMenuVisible.value = false
  mobileMenuOpen.value = false
  try {
    await axios.get('/api/test-data/create-firm-with-data')
    notifySuccess(t('admin.testData.createFirmSuccess'))
  } catch (e) {
    notifyError(t('admin.testData.createFirmError'))
  } finally {
    creatingFirm.value = false
  }
}

const logout = (): void => {
  // Use a custom modal instead of the browser's confirm dialog
  uiStore.setModal({
    title: t('auth.signOutConfirmTitle'),
    message: t('auth.signOutConfirmMessage'),
    confirmText: t('auth.confirmSignOut'),
    cancelText: t('auth.cancelSignOut'),
    onConfirm: () => {
      authStore.logout()
      closeMenu()
      uiStore.setModal(null)
    }
  })
}

const handleClickOutside = (event: MouseEvent): void => {
  // Close profile menu if clicked outside
  const profileContainer = document.querySelector('.app-header__profile')
  if (profileContainer && !profileContainer.contains(event.target as Node) && menuVisible.value) {
    closeMenu()
  }

  // Close admin menu if clicked outside (target only the admin-specific elements)
  const adminMenu = document.querySelector('.admin-nav-item')
  const adminDropdown = document.querySelector('.admin-dropdown')
  if (adminMenu && adminDropdown && !adminMenu.contains(event.target as Node) && adminMenuVisible.value) {
    adminMenuVisible.value = false
  }

  // Close tenders menu if clicked outside (target only the tenders-specific elements)
  const tendersMenu = document.querySelector('.tenders-nav-item')
  const tendersDropdown = document.querySelector('.tenders-dropdown')
  if (tendersMenu && tendersDropdown && !tendersMenu.contains(event.target as Node) && tendersMenuVisible.value) {
    tendersMenuVisible.value = false
  }

  // Close mobile menu if clicked on overlay
  const mobileNavOverlay = document.querySelector('.mobile-nav-overlay')
  const mobileNav = document.querySelector('.mobile-nav')
  if (mobileNavOverlay && mobileNavOverlay.contains(event.target as Node) &&
      (!mobileNav || !mobileNav.contains(event.target as Node)) && mobileMenuOpen.value) {
    mobileMenuOpen.value = false
  }
}

// Watchers
watch(getError, (newError: string | null) => {
  if (newError) {
    errorMessage.value = typeof newError === 'string' ? newError : 'An error occurred'
    // Clear error after 5 seconds
    setTimeout(() => {
      errorMessage.value = null
      uiStore.setError(null)
    }, 5000)
  }
})

watch(isAuthenticated, (newValue: boolean) => {
  if (newValue && !user.value) {
    authStore.fetchUser()
  }
})

watch(route, () => {
  closeMenu()
  mobileMenuOpen.value = false
})

// Lifecycle hooks
onMounted(() => {
  // Close menu when clicking outside
  document.addEventListener('click', handleClickOutside)
})

onBeforeUnmount(() => {
  // Clean up event listener
  document.removeEventListener('click', handleClickOutside)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "app-header__logo",
          onClick: goToHome
        }, [...(_cache[22] || (_cache[22] = [
          _createElementVNode("div", { class: "app-header__logo-icon" }, [
            _createElementVNode("img", {
              class: "app-header__logo-img",
              src: "/logo.png",
              alt: "Bati Vision 360 logo"
            })
          ], -1)
        ]))]),
        (isAuthenticated.value && !isInProjectView.value && !isInTenderView.value && !isInApplicationView.value)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "mobile-menu-button show-mobile",
              onClick: toggleMobileMenu,
              "aria-label": "Toggle navigation menu"
            }, [
              (!mobileMenuOpen.value)
                ? (_openBlock(), _createElementBlock("svg", _hoisted_4, [...(_cache[23] || (_cache[23] = [
                    _createElementVNode("path", {
                      d: "M3 12h18M3 6h18M3 18h18",
                      stroke: "currentColor",
                      "stroke-width": "2",
                      "stroke-linecap": "round"
                    }, null, -1)
                  ]))]))
                : (_openBlock(), _createElementBlock("svg", _hoisted_5, [...(_cache[24] || (_cache[24] = [
                    _createElementVNode("path", {
                      d: "M18 6L6 18M6 6l12 12",
                      stroke: "currentColor",
                      "stroke-width": "2",
                      "stroke-linecap": "round"
                    }, null, -1)
                  ]))]))
            ]))
          : _createCommentVNode("", true),
        (isAuthenticated.value && !isInProjectView.value && !isInTenderView.value && !isInApplicationView.value)
          ? (_openBlock(), _createElementBlock("nav", _hoisted_6, [
              _createElementVNode("ul", _hoisted_7, [
                _createElementVNode("li", {
                  class: _normalizeClass(["app-nav__item", { 'app-nav__item--active': isDashboardActive.value }])
                }, [
                  _createElementVNode("a", {
                    onClick: _withModifiers(goToUserHome, ["prevent"]),
                    class: "app-nav__link"
                  }, [
                    _cache[25] || (_cache[25] = _createElementVNode("div", { class: "app-nav__icon" }, [
                      _createElementVNode("svg", {
                        viewBox: "0 0 20 20",
                        width: "18",
                        height: "18"
                      }, [
                        _createElementVNode("path", {
                          fill: "currentColor",
                          d: "M10 2L3 9v11h4v-6h6v6h4V9l-7-7z"
                        })
                      ])
                    ], -1)),
                    _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('topBar.dashboard')), 1)
                  ])
                ], 2),
                _createVNode(PermissionGuard, { permission: "ACCESS_PROJECT" }, {
                  default: _withCtx(() => [
                    _createElementVNode("li", {
                      class: _normalizeClass(["app-nav__item", { 'app-nav__item--active': _ctx.$route.path === '/projects' }])
                    }, [
                      _createElementVNode("a", {
                        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (navigateTo('/projects')), ["prevent"])),
                        class: "app-nav__link",
                        "data-testid": "projects-nav-link"
                      }, [
                        _cache[26] || (_cache[26] = _createElementVNode("div", { class: "app-nav__icon" }, [
                          _createElementVNode("svg", {
                            viewBox: "0 0 20 20",
                            width: "18",
                            height: "18"
                          }, [
                            _createElementVNode("path", {
                              fill: "currentColor",
                              d: "M4 3h12a2 2 0 012 2v10a2 2 0 01-2 2H4a2 2 0 01-2-2V5a2 2 0 012-2zm0 2v3h12V5H4zm0 5v5h5v-5H4zm7 0v5h5v-5h-5z"
                            })
                          ])
                        ], -1)),
                        _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('topBar.projects')), 1)
                      ])
                    ], 2)
                  ]),
                  _: 1
                }),
                _createVNode(PermissionGuard, { permission: "ACCESS_PROJECT" }, {
                  default: _withCtx(() => [
                    _createElementVNode("li", {
                      class: _normalizeClass(["app-nav__item", { 'app-nav__item--active': _ctx.$route.path.includes('/calendar') }])
                    }, [
                      _createElementVNode("a", {
                        onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (navigateTo('/calendar')), ["prevent"])),
                        class: "app-nav__link"
                      }, [
                        _cache[27] || (_cache[27] = _createElementVNode("div", { class: "app-nav__icon" }, [
                          _createElementVNode("svg", {
                            viewBox: "0 0 20 20",
                            width: "18",
                            height: "18"
                          }, [
                            _createElementVNode("path", {
                              fill: "currentColor",
                              d: "M17 2h-1V1h-2v1H6V1H4v1H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 16H3V7h14v11zM3 5V4h14v1H3zm3 4h2v2H6V9zm4 0h2v2h-2V9zm4 0h2v2h-2V9z"
                            })
                          ])
                        ], -1)),
                        _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t('topBar.calendar')), 1)
                      ])
                    ], 2)
                  ]),
                  _: 1
                }),
                _createVNode(PermissionGuard, { permission: "ADMIN" }, {
                  default: _withCtx(() => [
                    _createElementVNode("li", {
                      class: _normalizeClass(["app-nav__item admin-nav-item", { 'app-nav__item--active': isAdminActive.value }]),
                      style: {"position":"relative"}
                    }, [
                      _createElementVNode("a", {
                        onClick: _withModifiers(toggleAdminMenu, ["prevent"]),
                        class: "app-nav__link",
                        role: "button",
                        "aria-expanded": adminMenuVisible.value,
                        "aria-haspopup": "true"
                      }, [
                        _cache[28] || (_cache[28] = _createElementVNode("div", { class: "app-nav__icon" }, [
                          _createElementVNode("svg", {
                            viewBox: "0 0 20 20",
                            width: "18",
                            height: "18"
                          }, [
                            _createElementVNode("path", {
                              fill: "currentColor",
                              d: "M10 2l2.5 5 5.5.8-4 3.9.9 5.5L10 15.5 4.1 17l.9-5.5L2 7.8 7.5 7z"
                            })
                          ])
                        ], -1)),
                        _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t('topBar.admin')), 1)
                      ], 8, _hoisted_11),
                      _createVNode(_Transition, { name: "dropdown-menu" }, {
                        default: _withCtx(() => [
                          (adminMenuVisible.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                _createElementVNode("ul", _hoisted_14, [
                                  _createElementVNode("li", {
                                    class: "dropdown__item",
                                    onClick: _cache[2] || (_cache[2] = ($event: any) => (navigateTo('/admin/subscriptions')))
                                  }, [
                                    _cache[29] || (_cache[29] = _createElementVNode("svg", {
                                      class: "dropdown__icon",
                                      viewBox: "0 0 24 24",
                                      width: "20",
                                      height: "20"
                                    }, [
                                      _createElementVNode("path", {
                                        fill: "currentColor",
                                        d: "M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
                                      })
                                    ], -1)),
                                    _createTextVNode(" " + _toDisplayString(_ctx.$t('topBar.subscriptions') || 'Subscriptions'), 1)
                                  ]),
                                  _createElementVNode("li", {
                                    class: "dropdown__item",
                                    onClick: _cache[3] || (_cache[3] = ($event: any) => (navigateTo('/admin/subscriptions/firms')))
                                  }, [
                                    _cache[30] || (_cache[30] = _createElementVNode("svg", {
                                      class: "dropdown__icon",
                                      viewBox: "0 0 24 24",
                                      width: "20",
                                      height: "20"
                                    }, [
                                      _createElementVNode("rect", {
                                        x: "3",
                                        y: "3",
                                        width: "18",
                                        height: "4",
                                        fill: "currentColor"
                                      }),
                                      _createElementVNode("rect", {
                                        x: "3",
                                        y: "9",
                                        width: "18",
                                        height: "12",
                                        fill: "currentColor"
                                      })
                                    ], -1)),
                                    _createTextVNode(" " + _toDisplayString(_ctx.$t('admin.firmSubscriptions.menu') || 'Firm Subscriptions'), 1)
                                  ]),
                                  _createElementVNode("li", {
                                    class: "dropdown__item",
                                    onClick: _cache[4] || (_cache[4] = ($event: any) => (navigateTo('/admin/contact-requests')))
                                  }, [
                                    _cache[31] || (_cache[31] = _createElementVNode("svg", {
                                      class: "dropdown__icon",
                                      viewBox: "0 0 24 24",
                                      width: "20",
                                      height: "20"
                                    }, [
                                      _createElementVNode("path", {
                                        fill: "currentColor",
                                        d: "M3 6h18v12H3z"
                                      })
                                    ], -1)),
                                    _createTextVNode(" " + _toDisplayString(_ctx.$t('admin.contactRequests.menu') || 'Contact Requests'), 1)
                                  ]),
                                  _createElementVNode("li", {
                                    class: "dropdown__item",
                                    onClick: _cache[5] || (_cache[5] = ($event: any) => (navigateTo('/admin/users')))
                                  }, [
                                    _cache[32] || (_cache[32] = _createElementVNode("svg", {
                                      class: "dropdown__icon",
                                      viewBox: "0 0 24 24",
                                      width: "20",
                                      height: "20"
                                    }, [
                                      _createElementVNode("path", {
                                        fill: "currentColor",
                                        d: "M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5s-3 1.34-3 3 1.34 3 3 3zM8 11c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V20h14v-3.5C15 14.17 10.33 13 8 13zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V20h6v-3.5C23 14.17 18.33 13 16 13z"
                                      })
                                    ], -1)),
                                    _createTextVNode(" " + _toDisplayString(_ctx.$t('topBar.users') || 'Users'), 1)
                                  ]),
                                  _createElementVNode("li", {
                                    class: _normalizeClass(["dropdown__item", { 'dropdown__item--loading': creatingFirm.value }]),
                                    onClick: createFirmWithData
                                  }, [
                                    _cache[33] || (_cache[33] = _createElementVNode("svg", {
                                      class: "dropdown__icon",
                                      viewBox: "0 0 24 24",
                                      width: "20",
                                      height: "20"
                                    }, [
                                      _createElementVNode("path", {
                                        fill: "currentColor",
                                        d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 14l-5-5 1.41-1.41L12 14.17l7.59-7.59L21 8l-9 9z"
                                      })
                                    ], -1)),
                                    _createTextVNode(" " + _toDisplayString(creatingFirm.value ? _ctx.$t('admin.testData.creating') : _ctx.$t('admin.testData.createFirm')), 1)
                                  ], 2)
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ], 2)
                  ]),
                  _: 1
                }),
                _createVNode(PermissionGuard, { permission: "ACCESS_TENDERS" }, {
                  default: _withCtx(() => [
                    _createElementVNode("li", {
                      class: _normalizeClass(["app-nav__item tenders-nav-item", { 'app-nav__item--active': isTendersActive.value }]),
                      style: {"position":"relative"}
                    }, [
                      _createElementVNode("a", {
                        onClick: _withModifiers(toggleTendersMenu, ["prevent"]),
                        class: "app-nav__link",
                        role: "button",
                        "aria-expanded": tendersMenuVisible.value,
                        "aria-haspopup": "true"
                      }, [
                        _cache[34] || (_cache[34] = _createElementVNode("div", { class: "app-nav__icon" }, [
                          _createElementVNode("svg", {
                            viewBox: "0 0 20 20",
                            width: "18",
                            height: "18"
                          }, [
                            _createElementVNode("path", {
                              fill: "currentColor",
                              d: "M14 2H6a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2V4a2 2 0 00-2-2zm-4 14H8v-2h2v2zm0-4H8V6h2v6zm4 4h-2v-2h2v2zm0-4h-2V6h2v6z"
                            })
                          ])
                        ], -1)),
                        _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t('topBar.tenders') || 'Tenders'), 1)
                      ], 8, _hoisted_15),
                      _createVNode(_Transition, { name: "dropdown-menu" }, {
                        default: _withCtx(() => [
                          (tendersMenuVisible.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                _createElementVNode("ul", _hoisted_18, [
                                  _createElementVNode("li", {
                                    class: "dropdown__item",
                                    onClick: _cache[6] || (_cache[6] = ($event: any) => (navigateTo('/tenders')))
                                  }, [
                                    _cache[35] || (_cache[35] = _createElementVNode("svg", {
                                      class: "dropdown__icon",
                                      viewBox: "0 0 24 24",
                                      width: "20",
                                      height: "20"
                                    }, [
                                      _createElementVNode("path", {
                                        fill: "currentColor",
                                        d: "M14 2H6a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2V4a2 2 0 00-2-2zm-4 14H8v-2h2v2zm0-4H8V6h2v6zm4 4h-2v-2h2v2zm0-4h-2V6h2v6z"
                                      })
                                    ], -1)),
                                    _createTextVNode(" " + _toDisplayString(_ctx.$t('topBar.tenders') || 'Tenders'), 1)
                                  ]),
                                  _createElementVNode("li", {
                                    class: "dropdown__item",
                                    onClick: _cache[7] || (_cache[7] = ($event: any) => (navigateTo('/my-applications')))
                                  }, [
                                    _cache[36] || (_cache[36] = _createElementVNode("svg", {
                                      class: "dropdown__icon",
                                      viewBox: "0 0 24 24",
                                      width: "20",
                                      height: "20"
                                    }, [
                                      _createElementVNode("path", {
                                        fill: "currentColor",
                                        d: "M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.1 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z"
                                      })
                                    ], -1)),
                                    _createTextVNode(" " + _toDisplayString(_ctx.$t('topBar.tenderApplications') || 'Tender Applications'), 1)
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ], 2)
                  ]),
                  _: 1
                })
              ])
            ]))
          : _createCommentVNode("", true),
        (isAuthenticated.value && isInProjectView.value)
          ? (_openBlock(), _createElementBlock("nav", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("button", {
                  onClick: goToUserHome,
                  class: "breadcrumb-item breadcrumb-home",
                  title: _ctx.$t('topBar.dashboard')
                }, [
                  _cache[37] || (_cache[37] = _createElementVNode("svg", {
                    viewBox: "0 0 20 20",
                    width: "16",
                    height: "16"
                  }, [
                    _createElementVNode("path", {
                      fill: "currentColor",
                      d: "M10 2L3 9v11h4v-6h6v6h4V9l-7-7z"
                    })
                  ], -1)),
                  _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.$t('topBar.dashboard')), 1)
                ], 8, _hoisted_21),
                _cache[40] || (_cache[40] = _createElementVNode("svg", {
                  class: "breadcrumb-separator",
                  viewBox: "0 0 24 24",
                  width: "14",
                  height: "14"
                }, [
                  _createElementVNode("path", {
                    fill: "currentColor",
                    d: "M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
                  })
                ], -1)),
                _createVNode(PermissionGuard, { permission: "ACCESS_PROJECT" }, {
                  default: _withCtx(() => [
                    _createElementVNode("button", {
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (navigateTo('/projects'))),
                      class: "breadcrumb-item",
                      title: _ctx.$t('topBar.projects')
                    }, [
                      _cache[38] || (_cache[38] = _createElementVNode("svg", {
                        viewBox: "0 0 20 20",
                        width: "14",
                        height: "14"
                      }, [
                        _createElementVNode("path", {
                          fill: "currentColor",
                          d: "M4 3h12a2 2 0 012 2v10a2 2 0 01-2 2H4a2 2 0 01-2-2V5a2 2 0 012-2zm0 2v3h12V5H4zm0 5v5h5v-5H4zm7 0v5h5v-5h-5z"
                        })
                      ], -1)),
                      _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.$t('topBar.projects')), 1)
                    ], 8, _hoisted_23)
                  ]),
                  _: 1
                }),
                _cache[41] || (_cache[41] = _createElementVNode("svg", {
                  class: "breadcrumb-separator",
                  viewBox: "0 0 24 24",
                  width: "14",
                  height: "14"
                }, [
                  _createElementVNode("path", {
                    fill: "currentColor",
                    d: "M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
                  })
                ], -1)),
                _createElementVNode("span", {
                  class: "breadcrumb-item breadcrumb-current",
                  title: currentProjectName.value
                }, [
                  _cache[39] || (_cache[39] = _createElementVNode("svg", {
                    viewBox: "0 0 20 20",
                    width: "14",
                    height: "14"
                  }, [
                    _createElementVNode("path", {
                      fill: "currentColor",
                      d: "M3 7V5C3 3.89543 3.89543 3 5 3H9L11 5H19C20.1046 5 21 5.89543 21 7V8H3V7ZM3 8H21V18C21 19.1046 20.1046 20 19 20H5C3.89543 20 3 19.1046 3 18V8Z"
                    })
                  ], -1)),
                  _createElementVNode("span", null, _toDisplayString(currentProjectName.value), 1)
                ], 8, _hoisted_25)
              ])
            ]))
          : _createCommentVNode("", true),
        (isAuthenticated.value && isInTenderView.value)
          ? (_openBlock(), _createElementBlock("nav", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("button", {
                  onClick: goToUserHome,
                  class: "breadcrumb-item breadcrumb-home",
                  title: _ctx.$t('topBar.dashboard')
                }, [
                  _cache[42] || (_cache[42] = _createElementVNode("svg", {
                    viewBox: "0 0 20 20",
                    width: "16",
                    height: "16"
                  }, [
                    _createElementVNode("path", {
                      fill: "currentColor",
                      d: "M10 2L3 9v11h4v-6h6v6h4V9l-7-7z"
                    })
                  ], -1)),
                  _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.$t('topBar.dashboard')), 1)
                ], 8, _hoisted_28),
                _cache[45] || (_cache[45] = _createElementVNode("svg", {
                  class: "breadcrumb-separator",
                  viewBox: "0 0 24 24",
                  width: "14",
                  height: "14"
                }, [
                  _createElementVNode("path", {
                    fill: "currentColor",
                    d: "M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
                  })
                ], -1)),
                _createVNode(PermissionGuard, { permission: "ACCESS_TENDERS" }, {
                  default: _withCtx(() => [
                    _createElementVNode("button", {
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (navigateTo('/tenders'))),
                      class: "breadcrumb-item",
                      title: _ctx.$t('topBar.tenders') || 'Tenders'
                    }, [
                      _cache[43] || (_cache[43] = _createElementVNode("svg", {
                        viewBox: "0 0 20 20",
                        width: "14",
                        height: "14"
                      }, [
                        _createElementVNode("path", {
                          fill: "currentColor",
                          d: "M14 2H6a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2V4a2 2 0 00-2-2zm-4 14H8v-2h2v2zm0-4H8V6h2v6zm4 4h-2v-2h2v2zm0-4h-2V6h2v6z"
                        })
                      ], -1)),
                      _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.$t('topBar.tenders') || 'Tenders'), 1)
                    ], 8, _hoisted_30)
                  ]),
                  _: 1
                }),
                _cache[46] || (_cache[46] = _createElementVNode("svg", {
                  class: "breadcrumb-separator",
                  viewBox: "0 0 24 24",
                  width: "14",
                  height: "14"
                }, [
                  _createElementVNode("path", {
                    fill: "currentColor",
                    d: "M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
                  })
                ], -1)),
                _createElementVNode("span", {
                  class: "breadcrumb-item breadcrumb-current",
                  title: currentTenderName.value
                }, [
                  _cache[44] || (_cache[44] = _createElementVNode("svg", {
                    viewBox: "0 0 20 20",
                    width: "14",
                    height: "14"
                  }, [
                    _createElementVNode("path", {
                      fill: "currentColor",
                      d: "M14 2H6a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2V4a2 2 0 00-2-2zm-4 14H8v-2h2v2zm0-4H8V6h2v6zm4 4h-2v-2h2v2zm0-4h-2V6h2v6z"
                    })
                  ], -1)),
                  _createElementVNode("span", null, _toDisplayString(currentTenderName.value), 1)
                ], 8, _hoisted_32)
              ])
            ]))
          : _createCommentVNode("", true),
        (isAuthenticated.value && isInApplicationView.value)
          ? (_openBlock(), _createElementBlock("nav", _hoisted_33, [
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("button", {
                  onClick: goToUserHome,
                  class: "breadcrumb-item breadcrumb-home",
                  title: _ctx.$t('topBar.dashboard')
                }, [
                  _cache[47] || (_cache[47] = _createElementVNode("svg", {
                    viewBox: "0 0 20 20",
                    width: "16",
                    height: "16"
                  }, [
                    _createElementVNode("path", {
                      fill: "currentColor",
                      d: "M10 2L3 9v11h4v-6h6v6h4V9l-7-7z"
                    })
                  ], -1)),
                  _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.$t('topBar.dashboard')), 1)
                ], 8, _hoisted_35),
                _cache[50] || (_cache[50] = _createElementVNode("svg", {
                  class: "breadcrumb-separator",
                  viewBox: "0 0 24 24",
                  width: "14",
                  height: "14"
                }, [
                  _createElementVNode("path", {
                    fill: "currentColor",
                    d: "M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
                  })
                ], -1)),
                _createVNode(PermissionGuard, { permission: "ACCESS_TENDER_APPLICATIONS" }, {
                  default: _withCtx(() => [
                    _createElementVNode("button", {
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (navigateTo('/my-applications'))),
                      class: "breadcrumb-item",
                      title: _ctx.$t('topBar.tenderApplications') || 'My Applications'
                    }, [
                      _cache[48] || (_cache[48] = _createElementVNode("svg", {
                        viewBox: "0 0 20 20",
                        width: "14",
                        height: "14"
                      }, [
                        _createElementVNode("path", {
                          fill: "currentColor",
                          d: "M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.1 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z"
                        })
                      ], -1)),
                      _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.$t('topBar.tenderApplications') || 'My Applications'), 1)
                    ], 8, _hoisted_37)
                  ]),
                  _: 1
                }),
                _cache[51] || (_cache[51] = _createElementVNode("svg", {
                  class: "breadcrumb-separator",
                  viewBox: "0 0 24 24",
                  width: "14",
                  height: "14"
                }, [
                  _createElementVNode("path", {
                    fill: "currentColor",
                    d: "M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
                  })
                ], -1)),
                _createElementVNode("span", {
                  class: "breadcrumb-item breadcrumb-current",
                  title: currentApplicationName.value
                }, [
                  _cache[49] || (_cache[49] = _createElementVNode("svg", {
                    viewBox: "0 0 20 20",
                    width: "14",
                    height: "14"
                  }, [
                    _createElementVNode("path", {
                      fill: "currentColor",
                      d: "M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.1 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z"
                    })
                  ], -1)),
                  _createElementVNode("span", null, _toDisplayString(currentApplicationName.value), 1)
                ], 8, _hoisted_39)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_40, [
        (isAuthenticated.value)
          ? (_openBlock(), _createBlock(NotificationIcon, { key: 0 }))
          : _createCommentVNode("", true),
        _createVNode(LanguageSelector),
        (_unref(loading))
          ? (_openBlock(), _createElementBlock("div", _hoisted_41, [...(_cache[52] || (_cache[52] = [
              _createElementVNode("div", { class: "loading-spinner" }, null, -1)
            ]))]))
          : _createCommentVNode("", true),
        (!isAuthenticated.value)
          ? (_openBlock(), _createBlock(AppButton, {
              key: 2,
              variant: "primary",
              onClick: login
            }, {
              "icon-left": _withCtx(() => [...(_cache[53] || (_cache[53] = [
                _createElementVNode("svg", {
                  viewBox: "0 0 20 20",
                  width: "16",
                  height: "16"
                }, [
                  _createElementVNode("path", {
                    fill: "currentColor",
                    d: "M3 3a2 2 0 012-2h.5a.5.5 0 010 1H5a1 1 0 00-1 1v12a1 1 0 001 1h.5a.5.5 0 010 1H5a2 2 0 01-2-2V3zM13.5 7a.5.5 0 01.5.5v1a.5.5 0 01-.5.5H8.207l1.646 1.646a.5.5 0 01-.708.708l-2.5-2.5a.5.5 0 010-.708l2.5-2.5a.5.5 0 01.708.708L8.207 7H13.5z"
                  })
                ], -1)
              ]))]),
              default: _withCtx(() => [
                _createTextVNode(" " + _toDisplayString(_ctx.$t('auth.signInBtn')), 1)
              ]),
              _: 1
            }))
          : (_openBlock(), _createElementBlock("div", _hoisted_42, [
              _createElementVNode("button", {
                class: "app-header__profile-button",
                onClick: toggleMenu,
                "aria-label": "User menu"
              }, [
                (user.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                      _createElementVNode("span", null, _toDisplayString(userInitials.value), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("span", _hoisted_44, _toDisplayString(user.value?.lastName || 'User'), 1),
                _cache[54] || (_cache[54] = _createElementVNode("svg", {
                  class: "app-header__dropdown-icon",
                  width: "10",
                  height: "6",
                  viewBox: "0 0 10 6",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, [
                  _createElementVNode("path", {
                    d: "M1 1L5 5L9 1",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  })
                ], -1))
              ]),
              _createVNode(_Transition, { name: "dropdown-menu" }, {
                default: _withCtx(() => [
                  (menuVisible.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                        _createElementVNode("ul", _hoisted_46, [
                          _createElementVNode("li", _hoisted_47, [
                            _createElementVNode("div", _hoisted_48, [
                              _createElementVNode("span", null, _toDisplayString(userInitials.value), 1)
                            ]),
                            _createElementVNode("div", _hoisted_49, [
                              _createElementVNode("span", _hoisted_50, _toDisplayString(user.value?.name || 'User'), 1),
                              _createElementVNode("span", _hoisted_51, _toDisplayString(user.value?.email || 'No email'), 1)
                            ])
                          ]),
                          _cache[64] || (_cache[64] = _createElementVNode("li", { class: "dropdown__divider" }, null, -1)),
                          _createElementVNode("li", {
                            onClick: goToUserHome,
                            class: "dropdown__item"
                          }, [
                            _cache[55] || (_cache[55] = _createElementVNode("svg", {
                              class: "dropdown__icon",
                              viewBox: "0 0 24 24",
                              width: "20",
                              height: "20"
                            }, [
                              _createElementVNode("path", {
                                fill: "currentColor",
                                d: "M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"
                              })
                            ], -1)),
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('topBar.dashboard')), 1)
                          ]),
                          _createVNode(PermissionGuard, { permission: "ACCESS_PROJECT" }, {
                            default: _withCtx(() => [
                              _createElementVNode("li", {
                                onClick: _cache[11] || (_cache[11] = ($event: any) => (navigateTo('/projects'))),
                                class: "dropdown__item"
                              }, [
                                _cache[56] || (_cache[56] = _createElementVNode("svg", {
                                  class: "dropdown__icon",
                                  viewBox: "0 0 24 24",
                                  width: "20",
                                  height: "20"
                                }, [
                                  _createElementVNode("path", {
                                    fill: "currentColor",
                                    d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14h-2v-4h-2v4H8v-7h2v2h2v-2h2v7zm3-9h-8V6h8v2z"
                                  })
                                ], -1)),
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('topBar.projects')), 1)
                              ])
                            ]),
                            _: 1
                          }),
                          _createVNode(PermissionGuard, { permission: "ADMIN" }, {
                            default: _withCtx(() => [
                              _createElementVNode("li", {
                                onClick: _cache[12] || (_cache[12] = ($event: any) => (navigateTo('/admin/subscriptions'))),
                                class: "dropdown__item"
                              }, [
                                _cache[57] || (_cache[57] = _createElementVNode("svg", {
                                  class: "dropdown__icon",
                                  viewBox: "0 0 24 24",
                                  width: "20",
                                  height: "20"
                                }, [
                                  _createElementVNode("path", {
                                    fill: "currentColor",
                                    d: "M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
                                  })
                                ], -1)),
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('topBar.subscriptions') || 'Subscriptions'), 1)
                              ]),
                              _createElementVNode("li", {
                                onClick: _cache[13] || (_cache[13] = ($event: any) => (navigateTo('/admin/contact-requests'))),
                                class: "dropdown__item"
                              }, [
                                _cache[58] || (_cache[58] = _createElementVNode("svg", {
                                  class: "dropdown__icon",
                                  viewBox: "0 0 24 24",
                                  width: "20",
                                  height: "20"
                                }, [
                                  _createElementVNode("path", {
                                    fill: "currentColor",
                                    d: "M3 6h18v12H3z"
                                  })
                                ], -1)),
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('admin.contactRequests.menu') || 'Contact Requests'), 1)
                              ]),
                              _createElementVNode("li", {
                                onClick: _cache[14] || (_cache[14] = ($event: any) => (navigateTo('/admin/users'))),
                                class: "dropdown__item"
                              }, [
                                _cache[59] || (_cache[59] = _createElementVNode("svg", {
                                  class: "dropdown__icon",
                                  viewBox: "0 0 24 24",
                                  width: "20",
                                  height: "20"
                                }, [
                                  _createElementVNode("path", {
                                    fill: "currentColor",
                                    d: "M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5s-3 1.34-3 3 1.34 3 3 3zM8 11c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V20h14v-3.5C15 14.17 10.33 13 8 13zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V20h6v-3.5C23 14.17 18.33 13 16 13z"
                                  })
                                ], -1)),
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('topBar.users') || 'Users'), 1)
                              ]),
                              _createElementVNode("li", {
                                onClick: createFirmWithData,
                                class: _normalizeClass(["dropdown__item", { 'dropdown__item--loading': creatingFirm.value }])
                              }, [
                                _cache[60] || (_cache[60] = _createElementVNode("svg", {
                                  class: "dropdown__icon",
                                  viewBox: "0 0 24 24",
                                  width: "20",
                                  height: "20"
                                }, [
                                  _createElementVNode("path", {
                                    fill: "currentColor",
                                    d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 14l-5-5 1.41-1.41L12 14.17l7.59-7.59L21 8l-9 9z"
                                  })
                                ], -1)),
                                _createTextVNode(" " + _toDisplayString(creatingFirm.value ? _ctx.$t('admin.testData.creating') : _ctx.$t('admin.testData.createFirm')), 1)
                              ], 2)
                            ]),
                            _: 1
                          }),
                          _createElementVNode("li", {
                            onClick: goToSettings,
                            class: "dropdown__item"
                          }, [
                            _cache[61] || (_cache[61] = _createElementVNode("svg", {
                              class: "dropdown__icon",
                              viewBox: "0 0 24 24",
                              width: "20",
                              height: "20"
                            }, [
                              _createElementVNode("path", {
                                fill: "currentColor",
                                d: "M19.14 12.94c.04-.3.06-.61.06-.94 0-.32-.02-.64-.07-.94l2.03-1.58c.18-.14.23-.41.12-.61l-1.92-3.32c-.12-.22-.37-.29-.59-.22l-2.39.96c-.5-.38-1.03-.7-1.62-.94l-.36-2.54c-.04-.24-.24-.41-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96c-.22-.08-.47 0-.59.22L2.74 8.87c-.12.21-.08.47.12.61l2.03 1.58c-.05.3-.09.63-.09.94s.02.64.07.94l-2.03 1.58c-.18.14-.23.41-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.05.24.24.41.48.41h3.84c.24 0 .44-.17.47-.41l.36-2.54c.59-.24 1.13-.56 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32c.12-.22.07-.47-.12-.61l-2.01-1.58zM12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6z"
                              })
                            ], -1)),
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('topBar.settings')), 1)
                          ]),
                          (user.value?.type === 'FIRM_OWNER')
                            ? (_openBlock(), _createElementBlock("li", {
                                key: 0,
                                onClick: _cache[15] || (_cache[15] = ($event: any) => (navigateTo('/my-subscription'))),
                                class: "dropdown__item"
                              }, [
                                _cache[62] || (_cache[62] = _createElementVNode("svg", {
                                  class: "dropdown__icon",
                                  viewBox: "0 0 24 24",
                                  width: "20",
                                  height: "20"
                                }, [
                                  _createElementVNode("path", {
                                    fill: "currentColor",
                                    d: "M12 2a7 7 0 100 14 7 7 0 000-14zm0 2a5 5 0 110 10A5 5 0 0112 4zM4 20v-1a7 7 0 0114 0v1H4z"
                                  })
                                ], -1)),
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('mySubscription.title')), 1)
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("li", {
                            onClick: logout,
                            class: "dropdown__item dropdown__item--danger"
                          }, [
                            _cache[63] || (_cache[63] = _createElementVNode("svg", {
                              class: "dropdown__icon",
                              viewBox: "0 0 24 24",
                              width: "20",
                              height: "20"
                            }, [
                              _createElementVNode("path", {
                                fill: "currentColor",
                                d: "M17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z"
                              })
                            ], -1)),
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('topBar.signOut')), 1)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]))
      ])
    ]),
    _createVNode(_Transition, { name: "mobile-menu" }, {
      default: _withCtx(() => [
        (mobileMenuOpen.value && isAuthenticated.value && !isInProjectView.value && !isInTenderView.value && !isInApplicationView.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
              _createElementVNode("nav", _hoisted_53, [
                _createElementVNode("ul", _hoisted_54, [
                  _createElementVNode("li", {
                    class: _normalizeClass(["mobile-nav__item", { 'mobile-nav__item--active': isDashboardActive.value }])
                  }, [
                    _createElementVNode("a", {
                      onClick: _withModifiers(goToUserHome, ["prevent"]),
                      class: "mobile-nav__link"
                    }, [
                      _cache[65] || (_cache[65] = _createElementVNode("div", { class: "mobile-nav__icon" }, [
                        _createElementVNode("svg", {
                          viewBox: "0 0 20 20",
                          width: "20",
                          height: "20"
                        }, [
                          _createElementVNode("path", {
                            fill: "currentColor",
                            d: "M10 2L3 9v11h4v-6h6v6h4V9l-7-7z"
                          })
                        ])
                      ], -1)),
                      _createElementVNode("span", _hoisted_55, _toDisplayString(_ctx.$t('topBar.dashboard')), 1)
                    ])
                  ], 2),
                  _createVNode(PermissionGuard, { permission: "ACCESS_PROJECT" }, {
                    default: _withCtx(() => [
                      _createElementVNode("li", {
                        class: _normalizeClass(["mobile-nav__item", { 'mobile-nav__item--active': _ctx.$route.path === '/projects' }])
                      }, [
                        _createElementVNode("a", {
                          onClick: _cache[16] || (_cache[16] = _withModifiers(($event: any) => (navigateTo('/projects')), ["prevent"])),
                          class: "mobile-nav__link"
                        }, [
                          _cache[66] || (_cache[66] = _createElementVNode("div", { class: "mobile-nav__icon" }, [
                            _createElementVNode("svg", {
                              viewBox: "0 0 20 20",
                              width: "20",
                              height: "20"
                            }, [
                              _createElementVNode("path", {
                                fill: "currentColor",
                                d: "M4 3h12a2 2 0 012 2v10a2 2 0 01-2 2H4a2 2 0 01-2-2V5a2 2 0 012-2zm0 2v3h12V5H4zm0 5v5h5v-5H4zm7 0v5h5v-5h-5z"
                              })
                            ])
                          ], -1)),
                          _createElementVNode("span", _hoisted_56, _toDisplayString(_ctx.$t('topBar.projects')), 1)
                        ])
                      ], 2)
                    ]),
                    _: 1
                  }),
                  _createVNode(PermissionGuard, { permission: "ADMIN" }, {
                    default: _withCtx(() => [
                      _createElementVNode("li", _hoisted_57, [
                        _createElementVNode("a", {
                          onClick: _cache[17] || (_cache[17] = _withModifiers(($event: any) => (navigateTo('/admin/subscriptions')), ["prevent"])),
                          class: "mobile-nav__link"
                        }, [
                          _cache[67] || (_cache[67] = _createElementVNode("div", { class: "mobile-nav__icon" }, [
                            _createElementVNode("svg", {
                              viewBox: "0 0 20 20",
                              width: "18",
                              height: "18"
                            }, [
                              _createElementVNode("path", {
                                fill: "currentColor",
                                d: "M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
                              })
                            ])
                          ], -1)),
                          _createElementVNode("span", _hoisted_58, _toDisplayString(_ctx.$t('topBar.subscriptions') || 'Subscriptions'), 1)
                        ])
                      ]),
                      _createElementVNode("li", _hoisted_59, [
                        _createElementVNode("a", {
                          onClick: _cache[18] || (_cache[18] = _withModifiers(($event: any) => (navigateTo('/admin/contact-requests')), ["prevent"])),
                          class: "mobile-nav__link"
                        }, [
                          _cache[68] || (_cache[68] = _createElementVNode("div", { class: "mobile-nav__icon" }, [
                            _createElementVNode("svg", {
                              viewBox: "0 0 20 20",
                              width: "18",
                              height: "18"
                            }, [
                              _createElementVNode("path", {
                                fill: "currentColor",
                                d: "M3 6h14v8H3z"
                              })
                            ])
                          ], -1)),
                          _createElementVNode("span", _hoisted_60, _toDisplayString(_ctx.$t('admin.contactRequests.menu')), 1)
                        ])
                      ]),
                      _createElementVNode("li", _hoisted_61, [
                        _createElementVNode("a", {
                          onClick: _cache[19] || (_cache[19] = _withModifiers(($event: any) => (navigateTo('/admin/users')), ["prevent"])),
                          class: "mobile-nav__link"
                        }, [
                          _cache[69] || (_cache[69] = _createElementVNode("div", { class: "mobile-nav__icon" }, [
                            _createElementVNode("svg", {
                              viewBox: "0 0 20 20",
                              width: "18",
                              height: "18"
                            }, [
                              _createElementVNode("path", {
                                fill: "currentColor",
                                d: "M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5s-3 1.34-3 3 1.34 3 3 3zM8 11c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V20h14v-3.5C15 14.17 10.33 13 8 13zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V20h6v-3.5C23 14.17 18.33 13 16 13z"
                              })
                            ])
                          ], -1)),
                          _createElementVNode("span", _hoisted_62, _toDisplayString(_ctx.$t('topBar.users') || 'Users'), 1)
                        ])
                      ]),
                      _createElementVNode("li", _hoisted_63, [
                        _createElementVNode("a", {
                          onClick: _withModifiers(createFirmWithData, ["prevent"]),
                          class: "mobile-nav__link"
                        }, [
                          _cache[70] || (_cache[70] = _createElementVNode("div", { class: "mobile-nav__icon" }, [
                            _createElementVNode("svg", {
                              viewBox: "0 0 20 20",
                              width: "18",
                              height: "18"
                            }, [
                              _createElementVNode("path", {
                                fill: "currentColor",
                                d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 14l-5-5 1.41-1.41L12 14.17l7.59-7.59L21 8l-9 9z"
                              })
                            ])
                          ], -1)),
                          _createElementVNode("span", _hoisted_64, _toDisplayString(creatingFirm.value ? _ctx.$t('admin.testData.creating') : _ctx.$t('admin.testData.createFirm')), 1)
                        ])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(PermissionGuard, { permission: "ACCESS_TENDERS" }, {
                    default: _withCtx(() => [
                      _createElementVNode("li", {
                        class: _normalizeClass(["mobile-nav__item", { 'mobile-nav__item--active': _ctx.$route.path.includes('/tenders') || _ctx.$route.path.includes('/my-applications') }])
                      }, [
                        _createElementVNode("a", {
                          onClick: _cache[20] || (_cache[20] = _withModifiers(($event: any) => (navigateTo('/tenders')), ["prevent"])),
                          class: "mobile-nav__link"
                        }, [
                          _cache[71] || (_cache[71] = _createElementVNode("div", { class: "mobile-nav__icon" }, [
                            _createElementVNode("svg", {
                              viewBox: "0 0 20 20",
                              width: "20",
                              height: "20"
                            }, [
                              _createElementVNode("path", {
                                fill: "currentColor",
                                d: "M14 2H6a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2V4a2 2 0 00-2-2zm-4 14H8v-2h2v2zm0-4H8V6h2v6zm4 4h-2v-2h2v2zm0-4h-2V6h2v6z"
                              })
                            ])
                          ], -1)),
                          _createElementVNode("span", _hoisted_65, _toDisplayString(_ctx.$t('topBar.tenders') || 'Tenders'), 1)
                        ])
                      ], 2),
                      _createElementVNode("li", {
                        class: _normalizeClass(["mobile-nav__item", { 'mobile-nav__item--active': _ctx.$route.path.includes('/my-applications') }])
                      }, [
                        _createElementVNode("a", {
                          onClick: _cache[21] || (_cache[21] = _withModifiers(($event: any) => (navigateTo('/my-applications')), ["prevent"])),
                          class: "mobile-nav__link",
                          style: {"padding-left":"3rem"}
                        }, [
                          _cache[72] || (_cache[72] = _createElementVNode("div", { class: "mobile-nav__icon" }, [
                            _createElementVNode("svg", {
                              viewBox: "0 0 20 20",
                              width: "20",
                              height: "20"
                            }, [
                              _createElementVNode("path", {
                                fill: "currentColor",
                                d: "M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.1 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z"
                              })
                            ])
                          ], -1)),
                          _createElementVNode("span", _hoisted_66, _toDisplayString(_ctx.$t('topBar.tenderApplications') || 'Tender Applications'), 1)
                        ])
                      ], 2)
                    ]),
                    _: 1
                  })
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})